import { objectOf, maybe, enumOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isPostAppSettingsComputeCustomAttributeUsageResult = objectOf({
  status: maybe(enumOf("ready", "too_large", "timed_out"), true),
  computed_at: maybe(number, true),
  cache_ttl_seconds: maybe(number, true),
  max_docs_per_collection: maybe(number, true),
});
